import { render, staticRenderFns } from "./alertDisabledAccount.vue?vue&type=template&id=26ef437f&lang=pug"
import script from "./alertDisabledAccount.vue?vue&type=script&lang=js"
export * from "./alertDisabledAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports